"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var Sections = require("sections");
var Theme = /** @class */ (function (_super) {
    __extends(Theme, _super);
    function Theme(props) {
        var _this = _super.call(this, props) || this;
        _this.cart = _this.props.data.cart;
        _this.state = {
            account: false,
            accountStep: null,
            cart: _this.cart,
            cartOpen: false,
            clickAndCollectOpen: false,
            headerOffsetHeight: null,
            locales: props.data.locales,
            searchTerms: props.data.search ? props.data.search.terms : "",
            shop: _this.props.data.shop,
            sizingOpen: false,
            wishlist: null
        };
        return _this;
    }
    Theme.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var match;
            return __generator(this, function (_a) {
                this.setState(__assign(__assign({}, this.state), this.context.state));
                this.context.update(__assign({}, this.state));
                next_components_1.ShopifyNext.Cart.init(this.context, this.props.data);
                if (Object.keys(this.props.data.customer).length != 0) {
                    if (next_components_1.ShopifyNext.Utils.getLocalStorage("theme:wishlist") != "") {
                        match = this.props.match;
                        if (this.props.data.template.name == "404") {
                            match = {
                                isExact: false,
                                params: {},
                                path: "/",
                                url: "/"
                            };
                        }
                        next_components_1.ShopifyNext.Wishlist.init(this.context, this.props.data, match);
                    }
                }
                next_components_1.ShopifyNext.Notifications.init(this.context, this.props.data);
                next_components_1.ShopifyNext.Helpers.init(this.context, this.props.data);
                if (Object.keys(this.props.data.customer).length == 0) {
                    if (next_components_1.ShopifyNext.Utils.getLocalStorage("theme:wishlist") != "") {
                        localStorage.removeItem("theme:wishlist");
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    Theme.prototype.render = function () {
        var _this = this;
        return (React.createElement(next_components_1.ShopifyNext.Context.Consumer, null, function (_a) {
            var state = _a.state, update = _a.update;
            return (React.createElement(React.Fragment, null,
                React.createElement(Sections.Header, __assign({}, _this.props, { section: _this.props.data.section.header })),
                !_this.props.data.section["404"] ? (_this.props.children) : (React.createElement("section", { className: "" },
                    React.createElement(Sections.Error, __assign({}, _this.props, { section: _this.props.data.section["404"] })))),
                React.createElement(Sections.Footer, __assign({}, _this.props, { section: _this.props.data.section.footer }))));
        }));
    };
    Theme.contextType = next_components_1.ShopifyNext.Context;
    return Theme;
}(React.Component));
exports.Theme = Theme;
